import { render, staticRenderFns } from "./ThgChargingStationForm.vue?vue&type=template&id=80878eca"
import script from "./ThgChargingStationForm.vue?vue&type=script&lang=ts"
export * from "./ThgChargingStationForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports